import React, {FC, useState} from "react";
import {FilePO} from "@/model/content";
import {GridActionsCellItem, GridColDef} from "@mui/x-data-grid";
import {checkFileType, formatTime, useAsyncEffect} from "@/helper/method";
import {FileDownloadOutlined, InsertLinkOutlined, SearchOutlined} from "@mui/icons-material";
import {ProTable} from "@/widget/ProTable/ProTable";
import {downloadFile, useQueryFilePage} from "@/service/file.s";
import {useGlobalActions} from "@/store/global.c";
import {mediaType} from "@/helper/constant";
import {isEmpty} from "lodash";

export interface ContractFileProps {
    contractId?: number
}

const {VITE_WEBSITE} = import.meta.env;

export const ContractFiles: FC<ContractFileProps> = ({contractId}) => {
    const {mutateAsync: filePageMutate} = useQueryFilePage()
    const [allFiles, setAllFiles] = useState<FilePO[]>([])
    const {setToast} = useGlobalActions()
    const columns: GridColDef<FilePO>[] = [
        {
            field: "name",
            headerName: "文件名称",
            headerAlign: "left",
            align: "left",
            flex: 0.6
        },
        {
            field: "type",
            headerName: "文件类型",
            headerAlign: "center",
            align: "center",
            flex: 0.4
        },
        {
            field: "size",
            headerName: "文件大小",
            headerAlign: "center",
            align: "center",
            flex: 0.5
        },
        {
            field: "createdAt",
            headerName: "上传日期",
            headerAlign: "center",
            flex: 0.5,
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        }, {
            field: "actions",
            type: "actions",
            flex: 0.54,
            headerName: "操作",
            getActions: ({row: {url, id, type, name, images}}) => {
                const link: string = `${VITE_WEBSITE}/preview?id=${id}`
                return [<GridActionsCellItem
                    icon={<FileDownloadOutlined/>}
                    label="下载"
                    color={'default'}
                    onClick={() => {
                        downloadFile({url, filename: name})
                    }}
                />, <GridActionsCellItem
                    icon={<InsertLinkOutlined/>}
                    label="复制链接"
                    color={'default'}
                    onClick={() => {
                        if (checkFileType(mediaType['image'], type)) {
                            navigator.clipboard.writeText(link)
                        } else {
                            navigator.clipboard.writeText(url)
                        }
                        setToast({open: true, message: "复制链接成功", variant: 'standard', severity: 'success'})
                    }}
                />, <GridActionsCellItem
                    icon={<SearchOutlined/>}
                    label="查看"
                    color={'default'}
                    onClick={() => {
                        if (checkFileType(mediaType['image'], type) || !isEmpty(images)) {
                            window.open(link)
                        } else {
                            setToast({open: true, message: "文件不支持预览，请下载查看", duration: 5000, variant: 'standard', severity: 'warning'})
                        }
                    }}
                />]
            }
        }]

    useAsyncEffect(async () => {
        if (contractId) {
            let allFiles: FilePO[] = []
            const resultAnnexe = await filePageMutate({size: 20, current: 1, targetId: contractId, tag: 1})
            const resultOriginal = await filePageMutate({size: 20, current: 1, targetId: contractId, tag: 11})
            if (resultAnnexe.code == 0) {
                allFiles = allFiles.concat(resultAnnexe!.data!.list!)
            }
            if (resultOriginal.code == 0) {
                allFiles = allFiles.concat(resultOriginal!.data!.list!)
            }
            setAllFiles(allFiles)
        }
    }, [contractId])
    return <ProTable<FilePO> checkboxSelection={false} showToolbar={false} columnHeaderHeight={40} source={{
        dataSource: {
            getRows: async () => {
                return {rows: allFiles, rowCount: allFiles.length}
            },
        },
        rowCount: allFiles.length || 0
    }} paginationMode={'client'} disableColumnResize={true} autoHeight={false}
                             columns={columns}/>
}